var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyfintoodark3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72351 6.75V9H15.2235V6.75C15.2235 4.67812 13.5454 3 11.4735 3C9.40164 3 7.72351 4.67812 7.72351 6.75ZM4.72351 9V6.75C4.72351 3.02344 7.74695 0 11.4735 0C15.2001 0 18.2235 3.02344 18.2235 6.75V9H18.9735C20.6282 9 21.9735 10.3453 21.9735 12V21C21.9735 22.6547 20.6282 24 18.9735 24H3.97351C2.31882 24 0.973511 22.6547 0.973511 21V12C0.973511 10.3453 2.31882 9 3.97351 9H4.72351Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyfintoodark3);
export default __webpack_public_path__ + "static/media/whyfintoodark3.246d43f909fa34dbba671d9f3c2b69e9.svg";
export { ForwardRef as ReactComponent };